import React from 'react'
import '../courses.css'
import Menubar from '../../home/menubar/Menubar'
import Address from '../../home/footer/Address'
import Carousel from '../../home/carousel/Carousel.jsx'
import Hower from '../../home/hower/Hower.jsx'
import Typewriter from '../../home/lazy loader/Typewriter.jsx'
import { msofficeImg, msofficeData, ms_gif } from '../../home/data.js'
import ScrollToTopProgress from '../../home/header/ScrollToTopProgress.jsx'
import Header from '../../home/header/Header.jsx'

function Msoffice() {
  const imgUrl = msofficeImg;
  const txt = msofficeData;
  const gif = ms_gif;
  return (
    <div>
        <Header/>
        <Menubar/>
        <Carousel imgUrl={imgUrl}/>
        <Hower gif={gif}/>
        <Typewriter txt={txt}/>

        <div className='pannel-container'>
          <div className="accordion accordion-flush" id="accordionFlushExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingOne">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
        <p className='panel-title'>Introduction to MS OFFICE</p>
      </button>
    </h2>
    <div id="flush-collapseOne" className="accordion-collapse collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
            <li className='list'>What is MS OFFICE ?</li>
            <li className='list'>Microsoft Word: Helps users in creating text documents</li>
            <li className='list'>Microsoft Excel: Creates simple to complex data/numerical spreadsheets</li>
            <li className='list'>Microsoft PowerPoint: Stand-alone application for creating professional multimedia presentations</li>
            <li className='list'>Microsoft Access: Database management application</li>
            <li className='list'>Microsoft Publisher: Introductory application for creating and publishing marketing materials</li>
            <li className='list'>Microsoft OneNote: Alternate to a paper notebook, it enables an user to neatly organize their notes</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingTwo">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
      <p className='panel-title'>MS Office Applications & its Functions</p>
      </button>
    </h2>
    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>Currently, MS Office 2016 version is being used across the world and all its applications are widely used for personal and professional purposes</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingThree">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
        <p className='panel-title'>MS Word</p>
      </button>
    </h2>
    <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>What is MS Word ?</li>
          <li className='list'>First released on October 25, 1983 </li>
          <li className='list'>Extension for Doc files is “.doc”</li>
          <li className='list'>It is useful in creating text documents</li>
          <li className='list'>Templates can be created for Professional use with the help of MS Word</li>
          <li className='list'>Work Art, colours, images, animations can be added along with the text in the same file which is downloadable in the form of a document</li>
          <li className='list'>Authors can use for writing/ editing their work</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingFour">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
        <p className='panel-title'>MS Excel</p>
      </button>
    </h2>
    <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>What is MS Excel ?</li>
          <li className='list'>Majorly used for making spreadsheets</li>
          <li className='list'>A spreadsheet consists of grids in the form of rows and columns which is easy to manage and can be used as a replacement for paper</li>
          <li className='list'>It is a data processing application</li>
          <li className='list'>Large data can easily be managed and saved in tabular format using MS Excel</li>
          <li className='list'>Calculations can be done based on the large amount of data entered into the cells of a spreadsheet within seconds</li>
          <li className='list'>File extension, when saved in the computer, is “.xls”</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingFive">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
        <p className='panel-title'>MS PowerPoint</p>
      </button>
    </h2>
    <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>What is MS PowerPoint ?</li>
          <li className='list'>It was released on April 20, 1987</li>
          <li className='list'>Used to create audiovisual presentations</li>
          <li className='list'>Each presentation is made up of various slides displaying data/ information</li>
          <li className='list'>Each slide may contain audio, video, graphics, text, bullet numbering, tables etc.</li>
          <li className='list'>The extension for PowerPoint presentations is “.ppt”</li>
          <li className='list'>Used majorly for professional usage</li>
          <li className='list'>Using PowerPoint, presentations can be made more interactive</li>
        </ul>
      </div>
    </div>
  </div>
          </div>
        </div>

        <div className="table-header">
	<h4><u><b>Microsoft Office Versions :</b></u></h4>
	<p>When the Office suite was first released, it was entirely devoted for usage in computer systems but later with time the Office suite was modified for use in Laptops, Tablets and Mobile phones.</p>
	<p>Given below are the various versions of Microsoft Office along with the years in which the version was released:</p>
<table className="table">
  <thead>
	<tr>
	<th colSpan="2" className="heading">Microsoft Office Versions</th>
	</tr>
<tr>
	<th className="sub-heading">Version name</th>
	<th className="sub-heading">Release Date/ Year</th>
</tr>
</thead>
<tbody>
<tr>
	<td>Microsoft Office for Windows</td>
	<td>October 1990</td>
</tr>
<tr>
	<td>Microsoft Office Microsoft Office 3.0</td>
	<td>August 30, 1992</td>
</tr>
<tr>
	<td>Microsoft Office 4.x (4.0 - 4.3)</td>
	<td>1994</td>
</tr>
<tr>
	<td>Microsoft Office 1995</td>
	<td>August 24, 1995</td>
</tr>
<tr>
	<td>Microsoft Office 1997</td>
	<td>1997</td>
</tr>
<tr>
	<td>Microsoft Office 2000</td>
	<td>June 7, 1997</td>
</tr>
<tr>
	<td>Microsoft Office XP (2002)</td>
	<td>May 31, 2001</td>
</tr>
<tr>
	<td>Microsoft Office 2003</td>
	<td>October 21, 2003</td>
</tr>
<tr>
	<td>Microsoft Office 2007</td>
	<td>January 30, 2007</td>
</tr>
<tr>
	<td>Microsoft Office 2010</td>
	<td>June 15, 2010</td>
</tr>
<tr>
	<td>Microsoft Office 2013</td>
	<td>January 30, 2012</td>
</tr>
<tr>
	<td>Microsoft Office 2016</td>
	<td>September 22, 2015</td>
</tr>
<tr>
	<td>Microsoft Office 2019</td>
	<td>September 24, 2018</td>
</tr>
<tr>
	<td>Microsoft Office 2021</td>
	<td>October 5, 2021</td>
</tr>
<tr>
	<td>Microsoft Office LTSC 2021</td>
	<td>October 5, 2021</td>
</tr>
<tr>
	<td>Microsoft 365 (formerly Office 365)</td>
	<td>Introduced June 28, 2011</td>
</tr>
</tbody>
</table>
</div>

        <Address/>
        <ScrollToTopProgress/>

    </div>
  )
}

export default Msoffice